
import FooterLinks from './Component';

import './styles.sass';

export default FooterLinks;
